module.exports = __webpack_public_path__ + "static/media/content-3.5ea882c4.png";